import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-right-front-fender',
    templateUrl: './question-damage-image-right-front-fender.component.html',
    styleUrls: ['./question-damage-image-right-front-fender.component.scss'],
    standalone: false
})
export class QuestionDamageImageRightFrontFenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
